import clsx from 'clsx';
import styles from './PageContent.module.scss';

interface PageContentProps {
  children: React.ReactNode;
  pageType: 'contentPage' | 'landingPage';
}

export const PageContent: React.FC<PageContentProps> = ({ children, pageType }) => (
  <div
    className={clsx(styles.pageContent, {
      [styles.contentPage]: pageType === 'contentPage',
      [styles.landingPage]: pageType === 'landingPage',
    })}
  >
    {children}
  </div>
);
